// TFDSelectChampionsLeague.js

import "./TFDSelectChampionsLeague.css"; // Import the new CSS file

import { Link } from "react-router-dom";

export default function TFDSelectChampionsLeague() {
	return (
		<div className="tfd-select-champions-page">
			{/* Hero Section */}
			<section className="tf-hero-champions">
				<div className="hero-image-wrap">
					<img
						src="/images/select/champions-hero.jpg"
						alt="Champions League Hero"
						className="hero-bg-image"
					/>
					<div className="overlay-dark" />
					<div className="hero-content themeflat-container">
						<h1 className="hero-title wow fadeInUp animated">
							Perth Champions League
						</h1>
						<p className="hero-subtitle wow fadeInUp animated">
							Growth, competition, and excellence at the highest level
						</p>
						<Link to="/contact" className="flat-button wow fadeInUp animated">
							Join the League
						</Link>
					</div>
				</div>
			</section>

			{/* Info Section */}
			<section className="tf-champions-info main-content">
				<div className="themeflat-container">
					<div className="row align-items-center">
						<div className="col-md-6 wow fadeInLeft animated">
							<div className="title-box title-small-v2">
								<span className="sub-title">Top-Tier Football</span>
								<h2 className="title-section">A Platform for Dreams</h2>
							</div>
							<p className="post">
								The Perth Champions League offers your child the chance to face
								the best young talent in Perth, sharpening their skills,
								decision-making, and resilience.
							</p>
							<ul className="list-check">
								<li>Professional organization &amp; trained referees</li>
								<li>Exposure to scouts, coaches, and clubs</li>
								<li>Supportive community for players &amp; parents</li>
							</ul>
							<p className="post">
								Ready to take the next step in competitive youth football? The
								Champions League is the ideal environment for every aspiring
								star.
							</p>
							<Link to="/contact" className="flat-button mt-3">
								Register Now
							</Link>
						</div>

						<div className="col-md-6 wow fadeInRight animated">
							<div className="image-wrapper">
								<img
									src="/images/select/champions-gallery.jpg"
									alt="Champions League Gallery"
									className="image-gr"
								/>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
}
